import {
    getChannelBaseNameByProviderType,
    getChannelGroupByProviderType,
} from '@/helpers/channels/channelCatalog'

export function getConnectorChannelDisplayName(
    connector: { providerType?: string; connectorType?: string; connectorId?: string; id?: string; createdAt?: number } | null | undefined,
    connectors: Array<{ providerType?: string; connectorType?: string; connectorId?: string; id?: string; createdAt?: number; isChisai?: boolean }> = []
): string {
    if (!connector) return ''

    const baseName = getChannelBaseNameByProviderType(connector.providerType || '')
    const groupKey =
        getChannelGroupByProviderType(connector.providerType || '') ||
        connector.connectorType ||
        'other'

    const sameGroup = (connectors || [])
        .filter((item) => !item?.isChisai)
        .filter(
            (item) =>
                (getChannelGroupByProviderType(item?.providerType || '') || item?.connectorType || 'other') ===
                groupKey
        )
        .sort((a, b) => {
            const aTime = a?.createdAt && a.createdAt > 0 ? a.createdAt : Number.MAX_SAFE_INTEGER
            const bTime = b?.createdAt && b.createdAt > 0 ? b.createdAt : Number.MAX_SAFE_INTEGER
            if (aTime !== Number.MAX_SAFE_INTEGER && bTime !== Number.MAX_SAFE_INTEGER) return aTime - bTime
            if (aTime === Number.MAX_SAFE_INTEGER && bTime !== Number.MAX_SAFE_INTEGER) return 1
            if (aTime !== Number.MAX_SAFE_INTEGER && bTime === Number.MAX_SAFE_INTEGER) return -1
            return String(a?.connectorId || a?.id || '').localeCompare(String(b?.connectorId || b?.id || ''))
        })

    const index = sameGroup.findIndex(
        (item) => (item?.connectorId || item?.id) === (connector.connectorId || connector.id)
    )
    const channelIndex = index >= 0 ? index + 1 : 1
    return channelIndex <= 1 ? baseName : `${baseName} ${channelIndex}`
}

export function applyCancelSubscriptionQueryParams(params: {
    renewalMode?: string | null
    channelName?: string | null
    periodTo?: string | null
}) {
    const newUrl = new URL(window.location.href)
    if (params.renewalMode === 'with_tariff') {
        newUrl.searchParams.set('cancelRenewalMode', 'with_tariff')
    } else {
        newUrl.searchParams.delete('cancelRenewalMode')
    }

    if (params.channelName !== undefined) {
        const channelName = String(params.channelName || '').trim()
        if (channelName) newUrl.searchParams.set('cancelChannelName', channelName)
        else newUrl.searchParams.delete('cancelChannelName')
    }

    if (params.periodTo !== undefined) {
        const periodTo = String(params.periodTo || '').trim()
        if (periodTo) newUrl.searchParams.set('cancelPeriodTo', periodTo)
        else newUrl.searchParams.delete('cancelPeriodTo')
    }

    window.history.replaceState({}, '', newUrl.toString())
}
